import { render, staticRenderFns } from "./Societe.vue?vue&type=template&id=baa36b4e"
import script from "./Societe.vue?vue&type=script&lang=js"
export * from "./Societe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports